module.exports = __webpack_public_path__ + "static/media/s2.918e784f.jpg";